import React from 'react';
import './Toast.css';

function Toast({ message, type, onClose, duration, index = 0 }) {
  // Ensure message is always displayed as a string
  const displayMessage = message ? String(message) : 'Unknown message';

  // Calculate vertical offset from bottom based on index (65px per toast)
  const bottomOffset = 20 + (index * 65);

  return (
    <div
      className={`toast-notification ${type}`}
      style={{ bottom: `${bottomOffset}px` }}
    >
      <div
        className={`toast-progress-bar ${type}`}
        style={{
          animationDuration: `${duration}ms`,
        }}
      />
      <div className="toast-content">
        <span className="toast-message">{displayMessage}</span>
        <button
          className="toast-close-btn"
          onClick={onClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;